<template>
  <FullScreenDialog
    v-model="paymentConditionDialog"
    title="Modifica condizione di pagamento"
    :routeFather="pathToGoBack"
  >
    <template v-slot:toolbar-extension>
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="tab in paymentConditionsTabs"
          :key="tab.key"
        >{{ tab.title }}</v-tab>
      </v-tabs>
    </template>

    <template v-slot:content>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in paymentConditionsTabs" :key="tabItem.key">
          <v-card flat>
            <v-card-text class="pa-0">
              <component :is="tabItem.component"></component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <template v-slot:footer-actions>
      <div>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          @click="$router.push({path: pathToGoBack})"
        >Annulla</v-btn>
        <v-btn
          text
          color="default"
          :disabled="!formValid"
          @click="submitForm"
        >Salva</v-btn>
      </div>
    </template>

<!-- KEEP COMMENT - ONEWARE-562    
   <template v-slot:header-actions>
      <div>
        <StandardMenu
          close-on-content-click
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-on="on" v-bind="attrs">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item link>
                <v-list-item-icon class="mr-3">
                  <v-icon>mdi-printer</v-icon>
                </v-list-item-icon>
                <v-list-item-content>Stampa</v-list-item-content>
              </v-list-item>
              <v-list-item link>
                <v-list-item-icon class="mr-3">
                  <v-icon color="error">mdi-backspace-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="error--text">Resetta</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </StandardMenu>
      </div>
    </template> -->
  </FullScreenDialog>
</template>

<script>
import FullScreenDialog from "@/components/common/FullScreenDialog.vue";
import StandardMenu from '@/components/common/StandardMenu.vue';
import GeneralForm from "@/components/areas/payments/paymentConditions/form/GeneralFormTab.vue"
import paymentConditionsService from '@/services/paymentTerms/paymentConditions.service.js'
import paymentConditionForm from '@/services/paymentTerms/paymentCondition.form.js'

export default {
  name: "PaymentConditionsEditForm",
  components: {
    FullScreenDialog,
    StandardMenu,
    GeneralForm
  },
  data: function () {
    return {
      id: undefined,
      tab: null,
      formValid: false,
      loadingPaymentCondition: false,
      paymentConditionDialog: this.openDialog,
      paymentConditionsTabs: [
        {
          key: 0,
          title: "Generale",
          name: "general",
          component: "GeneralForm"
        }
      ],
      paymentCondition: undefined,
      originalUrl: window.location.pathname
    };
  },
  mounted() {
    this.changeTabBasedOnProp(this.tabName)

    this.id = this.$route.params.id
    if(this.id) {
      this.fetchPaymentCondition()
    }


    let self = this
    paymentConditionForm.on('update', function(data) {
      self.paymentCondition = data.paymentCondition
    })

    self.valid = paymentConditionForm.valid
    paymentConditionForm.on('valid-change', function(valid) {
      self.formValid = valid
    })
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    pathToGoBack: {
      type: String,
      default: "/payments",
    },
    tabName: {
      type: String,
      default: 'general'
    }
  },
  methods: {
    changeTabBasedOnProp(tabName) {
      for(let i = 0; i < this.paymentConditionsTabs.length; i++) {
        if(this.paymentConditionsTabs[i].name == tabName) {
          this.tab = i
          break
        }
      }
    },
    submitForm() {
      paymentConditionsService.update(this.paymentCondition).then((result) => {
        this.$router.push({path: this.pathToGoBack})
      })
    },
    fetchPaymentCondition() {
      this.loadingPaymentCondition = true
      paymentConditionForm.resetPaymentCondition()
      paymentConditionsService.get(this.id).then((paymentCondition) => {
        this.loadingPaymentCondition = false
        paymentConditionForm.updateObject(paymentCondition)
      })
    }
  },
  watch: {
    openDialog(newVal) {
      this.paymentConditionDialog = newVal;
    },
    tab(newVal) {
      try {
        window.history.pushState("Tab", "Tab", this.originalUrl + '?tabName=' + this.paymentConditionsTabs[newVal].name);
      } catch(err) {
        console.log('try setting the tab name but something goes wrong')
      }
    }
  },
};
</script>